export enum PaymentStatusEnum {
    PAID = 'PAID',
    NOT_PAID = 'NOT_PAID',
    PAYMENT_IN_PROGRESS = 'PAYMENT_IN_PROGRESS',
    REFUND_IN_PROGRESS = 'REFUND_IN_PROGRESS',
    REFUNDED = 'REFUNDED',
    REFUND_FAILED = 'REFUND_FAILED'
}
